import { render, staticRenderFns } from "./PedidosPermitirEditarContrato.vue?vue&type=template&id=cc0673b8"
import script from "./PedidosPermitirEditarContrato.vue?vue&type=script&lang=js"
export * from "./PedidosPermitirEditarContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports